/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "Pan",
        "0": "Walɛ",
        "1": "Ruun",
        "future": {
          "other": "+{0} d"
        },
        "past": {
          "other": "-{0} d"
        }
      },
      "day-narrow": {
        "-1": "Pan",
        "0": "Walɛ",
        "1": "Ruun",
        "future": {
          "other": "+{0} d"
        },
        "past": {
          "other": "-{0} d"
        }
      },
      "day-short": {
        "-1": "Pan",
        "0": "Walɛ",
        "1": "Ruun",
        "future": {
          "other": "+{0} d"
        },
        "past": {
          "other": "-{0} d"
        }
      },
      "hour": {
        "0": "this hour",
        "future": {
          "other": "+{0} h"
        },
        "past": {
          "other": "-{0} h"
        }
      },
      "hour-narrow": {
        "0": "this hour",
        "future": {
          "other": "+{0} h"
        },
        "past": {
          "other": "-{0} h"
        }
      },
      "hour-short": {
        "0": "this hour",
        "future": {
          "other": "+{0} h"
        },
        "past": {
          "other": "-{0} h"
        }
      },
      "minute": {
        "0": "this minute",
        "future": {
          "other": "+{0} min"
        },
        "past": {
          "other": "-{0} min"
        }
      },
      "minute-narrow": {
        "0": "this minute",
        "future": {
          "other": "+{0} min"
        },
        "past": {
          "other": "-{0} min"
        }
      },
      "minute-short": {
        "0": "this minute",
        "future": {
          "other": "+{0} min"
        },
        "past": {
          "other": "-{0} min"
        }
      },
      "month": {
        "-1": "last month",
        "0": "this month",
        "1": "next month",
        "future": {
          "other": "+{0} m"
        },
        "past": {
          "other": "-{0} m"
        }
      },
      "month-narrow": {
        "-1": "last month",
        "0": "this month",
        "1": "next month",
        "future": {
          "other": "+{0} m"
        },
        "past": {
          "other": "-{0} m"
        }
      },
      "month-short": {
        "-1": "last month",
        "0": "this month",
        "1": "next month",
        "future": {
          "other": "+{0} m"
        },
        "past": {
          "other": "-{0} m"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "quarter-narrow": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "quarter-short": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "second": {
        "0": "now",
        "future": {
          "other": "+{0} s"
        },
        "past": {
          "other": "-{0} s"
        }
      },
      "second-narrow": {
        "0": "now",
        "future": {
          "other": "+{0} s"
        },
        "past": {
          "other": "-{0} s"
        }
      },
      "second-short": {
        "0": "now",
        "future": {
          "other": "+{0} s"
        },
        "past": {
          "other": "-{0} s"
        }
      },
      "week": {
        "-1": "last week",
        "0": "this week",
        "1": "next week",
        "future": {
          "other": "+{0} w"
        },
        "past": {
          "other": "-{0} w"
        }
      },
      "week-narrow": {
        "-1": "last week",
        "0": "this week",
        "1": "next week",
        "future": {
          "other": "+{0} w"
        },
        "past": {
          "other": "-{0} w"
        }
      },
      "week-short": {
        "-1": "last week",
        "0": "this week",
        "1": "next week",
        "future": {
          "other": "+{0} w"
        },
        "past": {
          "other": "-{0} w"
        }
      },
      "year": {
        "-1": "last year",
        "0": "this year",
        "1": "next year",
        "future": {
          "other": "+{0} y"
        },
        "past": {
          "other": "-{0} y"
        }
      },
      "year-narrow": {
        "-1": "last year",
        "0": "this year",
        "1": "next year",
        "future": {
          "other": "+{0} y"
        },
        "past": {
          "other": "-{0} y"
        }
      },
      "year-short": {
        "-1": "last year",
        "0": "this year",
        "1": "next year",
        "future": {
          "other": "+{0} y"
        },
        "past": {
          "other": "-{0} y"
        }
      }
    },
    "locale": "nus"
  });
}